export default "__VITE_ASSET__DXFepREM__"